import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/i18n';
import App from './App.tsx';
import { bootstrapLogRocketConsentListener } from '@/lib/consent';
import '@/styles/global.css';

bootstrapLogRocketConsentListener();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
